import { render, staticRenderFns } from "./SignaturePad.vue?vue&type=template&id=032d5004"
import script from "./SignaturePad.vue?vue&type=script&lang=js"
export * from "./SignaturePad.vue?vue&type=script&lang=js"
import style0 from "./SignaturePad.vue?vue&type=style&index=0&id=032d5004&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports